import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const PinIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0.666504C4.4087 0.666504 2.88258 1.29864 1.75736 2.42386C0.632141 3.54908 0 5.0752 0 6.6665C0.000650101 7.17226 0.0633405 7.67602 0.186667 8.1665C0.893333 11.1332 3.73933 13.9065 5.15933 15.0332C5.39629 15.2272 5.69309 15.3332 5.99933 15.3332C6.30557 15.3332 6.60238 15.2272 6.83933 15.0332C8.306 13.8732 11.306 10.9465 11.8787 7.87317C12.0557 7.00119 12.037 6.10077 11.8238 5.23691C11.6106 4.37306 11.2082 3.56731 10.6458 2.87783C10.0834 2.18835 9.37488 1.63234 8.57147 1.24993C7.76806 0.867522 6.88977 0.668252 6 0.666504ZM6 8.6665C5.60444 8.6665 5.21776 8.54921 4.88886 8.32944C4.55996 8.10968 4.30362 7.79732 4.15224 7.43187C4.00087 7.06642 3.96126 6.66429 4.03843 6.27632C4.1156 5.88836 4.30608 5.532 4.58579 5.25229C4.86549 4.97259 5.22186 4.7821 5.60982 4.70493C5.99778 4.62776 6.39991 4.66737 6.76537 4.81874C7.13082 4.97012 7.44318 5.22646 7.66294 5.55536C7.8827 5.88426 8 6.27094 8 6.6665C8 7.19694 7.78929 7.70564 7.41421 8.08072C7.03914 8.45579 6.53043 8.6665 6 8.6665Z"
      fill="currentColor"
    />
  </svg>
));

PinIcon.displayName = 'PinIcon';

export default PinIcon;
